import { render, staticRenderFns } from "./CertificationsListFiltersForm.vue?vue&type=template&id=164cbd9c&scoped=true&"
import script from "./CertificationsListFiltersForm.vue?vue&type=script&lang=js&"
export * from "./CertificationsListFiltersForm.vue?vue&type=script&lang=js&"
import style0 from "./CertificationsListFiltersForm.vue?vue&type=style&index=0&id=164cbd9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164cbd9c",
  null
  
)

export default component.exports